/**
 * Centralized logging utility to replace console statements
 * Allows for proper error tracking and production-safe logging
 */

const logger = {
  /**
   * Log information messages (development only)
   * @param {string} message - Log message
   * @param {any} data - Additional data to log
   */
  info: (message, data = null) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[INFO] ${message}`, data || '');
    }
    // In production, could send to logging service
    // sendToLoggingService('info', message, data);
  },

  /**
   * Log warning messages
   * @param {string} message - Warning message
   * @param {any} data - Additional data to log
   */
  warn: (message, data = null) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[WARN] ${message}`, data || '');
    }
    // Send to error tracking service in production
    // sendToErrorTrackingService('warn', message, data);
  },

  /**
   * Log error messages
   * @param {string} message - Error message
   * @param {Error|any} error - Error object or additional data
   */
  error: (message, error = null) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(`[ERROR] ${message}`, error || '');
    }
    // Always log errors, even in production
    // sendToErrorTrackingService('error', message, error);
    
    // Example: Send to Sentry, LogRocket, etc.
    if (process.env.NODE_ENV === 'production' && error) {
      // Example integration:
      // import * as Sentry from '@sentry/react';
      // Sentry.captureException(error);
    }
  },

  /**
   * Log debug messages (development only)
   * @param {string} message - Debug message
   * @param {any} data - Additional data to log
   */
  debug: (message, data = null) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug(`[DEBUG] ${message}`, data || '');
    }
  },

  /**
   * Log API requests
   * @param {string} method - HTTP method
   * @param {string} url - API endpoint
   * @param {any} data - Request data
   */
  api: (method, url, data = null) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[API] ${method.toUpperCase()} ${url}`, data || '');
    }
  }
};

export default logger;












